module.exports = __webpack_public_path__ + "img/public/SiteIcons/information-button.svg?1edbfba1";